module.exports = __webpack_public_path__ + "static/img/3.bc3b64c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/zh/3.png
// module id = x044
// module chunks = 0